<template>
  <va-edit-layout>
    <Report-form :id="id" :title="title" :item="item"></Report-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
